import React, { useEffect } from 'react'
import Header from '../../../headerone/Main'
import Bredcom from '../../../Bredcom/Main'
import CommercialPermit from '../../menforms/form/CommercialPermit'
// import Mayor from '../../menhome/Mayor'
// import Second from '../../menhome/Client'

function Main() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Commercial Permit || Forms";
  }, [])

  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
          <Bredcom 
            subtitle="Forms"
            title="Commercial Permit"
            subtitledown="Commercial Permit"
           />
            <CommercialPermit/>
            {/* <Mayor/>
            <Second/> */}
        </div>
    </>
  )
}

export default Main